export default function PrivacyPage() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-10 prose prose-invert">
      <h1 className="text-3xl font-bold mb-2">Privacy Policy</h1>
      <p className="text-white/50 text-sm mb-8">Last updated: {new Date().toLocaleDateString()}</p>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">1. What we collect</h2>
        <p className="text-white/80 leading-relaxed">
          When you sign in with Google or Apple, Setback receives your email address and name as provided by that
          service (Apple may use a private relay address and may not always provide a name after the first sign-in), and
          with Google we may receive your profile photo. We also ask you directly for a screen name. During gameplay we
          store match history,
          individual hand records, and aggregated stats. We record the timestamp of your sign-in sessions for security
          purposes. We do not collect your physical location, contacts, or any other information.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">2. Why we collect it</h2>
        <p className="text-white/80 leading-relaxed">
          We collect your email and sign-in profile info (from Google or Apple) to authenticate you. We collect your
          screen name so other
          players can identify you at the table. We collect gameplay data to save your progress, show your stats,
          enable hand replay, and detect abuse.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">3. How we store it</h2>
        <p className="text-white/80 leading-relaxed">
          Your data is stored in Google Firebase, hosted on Google Cloud infrastructure in the United States. Data is
          encrypted in transit and at rest. We do not maintain our own servers, databases, or backups beyond Firebase.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">4. Who we share it with</h2>
        <p className="text-white/80 leading-relaxed">
          Nobody outside Google/Firebase services. We do not sell data. We do not use third-party analytics trackers,
          advertising networks, or marketing tools in this version of the app. Your screen name and gameplay stats
          are visible to players in the same match as you — that is the only way other users see any of your data.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">5. Younger players</h2>
        <p className="text-white/80 leading-relaxed">
          Setback has no chat, direct messaging, or open-ended user-generated feeds; the only free-text element is your
          screen name. Parents and guardians decide whether the game is appropriate for minors in their care. To request
          removal of an account, contact nickbauer540@gmail.com.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">6. Your rights</h2>
        <p className="text-white/80 leading-relaxed">
          You can export all of your data or delete your account at any time from the profile settings page.
          Deleting your account removes your user profile immediately; historical match records are anonymized so
          other players' games are not destroyed. These controls are available to all users regardless of
          jurisdiction, and satisfy access and erasure rights under GDPR and similar laws.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">7. Changes to this policy</h2>
        <p className="text-white/80 leading-relaxed">
          If we change this policy materially, we will prompt you to re-accept it the next time you sign in. Minor
          wording changes will be noted by updating the "Last updated" date at the top of this page.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">8. Contact</h2>
        <p className="text-white/80 leading-relaxed">
          For privacy questions or requests: nickbauer540@gmail.com
        </p>
      </section>

      {/* Note to app owner: This is a reasonable starting template based on the
          data Setback currently collects. For production use beyond family and
          friends, have this reviewed by an attorney before shipping publicly. */}
    </div>
  );
}
